export interface OperationalExceptionAttention {
  code: string;
  severity: string;
  needs_attention?: boolean;
}

/** FastAPI owns the queue policy; the fallback supports staggered deployment. */
export function operationalExceptionNeedsAttention(item: OperationalExceptionAttention): boolean {
  if (typeof item.needs_attention === "boolean") return item.needs_attention;
  if ([
    "booking_operation_failed",
    "booking_policy_rejected",
    "booking_prewrite_rejected",
    "lesson_block_coupon_ineligible",
  ].includes(item.code)) return false;
  if ([
    "booking_reconciliation_required",
    "booking_mutation_outcome_unknown",
    "booking_override_configuration_failed",
    "booking_operation_stalled",
    "booking_move_outcome_unknown",
  ].includes(item.code)) return true;
  return item.severity === "action" || item.severity === "error";
}
